import React from 'react';
import { Fade, Modal } from '@material-ui/core';
import images from '../assets';
import { ModalNorBtn, HorizontalSp, VerticalSp, MediaQuery, ModalTitle } from '../components/Common';
import io from 'socket.io-client';
import { useEffect, useState, useRef } from 'react';
import Store from 'store';
import { useTranslation } from 'react-i18next';
import { isBrowser, isMobile } from 'react-device-detect';
import { getModalWidh } from '../_utils/modalWidh';
import { InView } from 'react-intersection-observer';
import getPrewImage from '../_utils/preview';
import Ratio from 'react-ratio';
import { Height } from '@material-ui/icons';
import { Button } from '@material-ui/core';
import { getCurrentLang, getStringByLang } from '../libs/lang';

const marqueeStyle = {
  display: 'inline-block',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  animation: 'marquee 10s linear infinite',
};

const keyframesStyle = `
  @keyframes marquee {
    0% {
      transform: translateX(100%);
    }
    100% {
      transform: translateX(-100%);
    }
  }
`;

export const AiEventtModal = ({ show, onClose, goResultPage, generate_step }) => {
  const [progress, setProgress] = useState(0);
  const progressCntRef = useRef(null);
  const lang = getCurrentLang();
  const videoSrc =
    lang === 'kr'
      ? `${process.env.REACT_APP_S3_BUCKET_DOMAIN}/tdb/storage/uploads/event/tdb_ad_kr.mp4`
      : `${process.env.REACT_APP_S3_BUCKET_DOMAIN}/tdb/storage/uploads/event/tdb_ad_en.mp4`;

  useEffect(() => {
    if (show) {
      if (progress < generate_step * 20) {
        progressCntRef.current = generate_step * 20;
        setProgress(generate_step * 20);
      }
      const interval = setInterval(() => {
        if (progress <= generate_step * 20 + 20 && progress < 99) {
          progressCntRef.current = progressCntRef.current + 1;
          setProgress(progressCntRef.current); // 상태 업데이트는 반드시 이전 상태값을 기반으로
        }
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [show, goResultPage, progress]);

  const getWidth = () => {
    const width = window.innerWidth;
    return width > 1424 ? '60%' : width > 1224 ? '65%' : width > 1024 ? '70%' : '90%';
  };

  return (
    <>
      <style>
        {`
            .progress-container {
              position: relative;
              width: 60%;
              height: 18px;
              background-color: #e0e0e0;
              border-radius: 15px;
              overflow: hidden;
              margin: 6px 0;
            }
            .progress-bar {
              height: 100%;
              background-color: #ff8a06;
              width: ${progress}%;
              border-radius: 15px 0 0 15px;
              transition: width 0.3s ease;
              border-radius: 15px;
            }
            .progress-text {
              position: absolute;
              width: 100%;
              top: 50%;
              transform: translateY(-50%);
              text-align: center;
              font-weight: bold;
              color: white;
              font-size: 16px;
            }
          `}
      </style>
      <Modal
        style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999 }}
        open={show}
        onClose={onClose}
      >
        <Fade in={show}>
          <div style={{ display: 'flex', width: getWidth(), alignItems: 'center', justifyContent: 'center' }}>
            <ModalContents style={{ padding: 15 }} onClose={onClose}>
              <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                <div style={{ width: 'auto', overflow: 'hidden' }}>
                  <p style={{ ...marqueeStyle, fontWeight: 'bold', fontSize: 32, margin: 0 }}>
                    {getStringByLang(
                      'AI 텍스타일 디자인 생성 중입니다.',
                      'Creating AI-Generated Textile Designs.',
                      'AIテキスタイルデザインを生成中です。',
                    )}
                  </p>
                </div>

                {/* 프로그래스바 */}
                <div className="progress-container">
                  <div className="progress-bar">
                    <span className="progress-text">{progress}%</span>
                  </div>
                </div>

                <p style={{ marginBottom: 5, marginTop: 10 }}>
                  {getStringByLang(
                    '이미지 생성은 30초~1분정도가 소요됩니다. 잠시만 기다려주세요.',
                    'Image generation takes about 30 seconds to 1 minute. Please wait a moment.',
                    '画像の生成には30秒から1分ほどかかります。しばらくお待ちください。',
                  )}
                </p>
                <p style={{ marginBottom: 10, marginTop: 0 }}>
                  {getStringByLang(
                    '*생성이 완료되면',
                    '*Once the generation is complete, you will be',
                    '*生成が完了すると、',
                  )}
                  &nbsp;
                  <strong>
                    {getStringByLang('자동으로 상세보기 페이지로', 'automatically redirected', '自動的に詳細ページに')}
                  </strong>
                  &nbsp;
                  {getStringByLang('이동됩니다.', 'to the details page.', '移動します。')}
                </p>

                <video width={window.innerWidth > 1224 ? '80%' : '95%'} autoPlay loop muted>
                  <source src={videoSrc} type="video/mp4" />
                  {getStringByLang(
                    '비디오 태그를 지원하지 않는 브라우저입니다.',
                    'Your browser does not support the video tag.',
                    'このブラウザはビデオタグをサポートしていません。',
                  )}
                </video>

                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginTop: 10,
                    width: '50%',
                  }}
                >
                  <ModalNorBtn
                    style={{
                      backgroundColor: '#ffffff',
                      color: '#ff8a06',
                      borderStyle: 'solid',
                      borderColor: '#ff8a06',
                      borderWidth: 'thin',
                      padding: '0px 5px',
                      width: window.innerWidth > 1224 ? '40%' : '70%',
                    }}
                    onClick={onClose}
                  >
                    {getStringByLang('돌아가기', 'Back', '戻る')}
                  </ModalNorBtn>
                  <HorizontalSp sp={10} />
                  <ModalNorBtn
                    style={{
                      backgroundColor: '#ff8a06',
                      padding: '0px 5px',
                      width: window.innerWidth > 1224 ? '40%' : '70%',
                    }}
                    onClick={goResultPage}
                  >
                    {getStringByLang('목록 이동', 'Go to result list', 'リストに移動')}
                  </ModalNorBtn>
                </div>
              </div>
            </ModalContents>
          </div>
        </Fade>
      </Modal>
    </>
  );
};

export const BlockTitle = ({ children }) => {
  return (
    <>
      <MediaQuery min={700}>
        <div style={{ fontFamily: 'NSCJKrB', color: 'black', fontSize: 50, textAlign: 'center' }}>{children}</div>
      </MediaQuery>
      <MediaQuery max={699}>
        <div style={{ fontFamily: 'NSCJKrB', color: 'black', fontSize: 24, textAlign: 'center' }}>{children}</div>
      </MediaQuery>
    </>
  );
};

export const ChoiseFileModal = ({ show, onClose, onDownloadFileChoice }) => {
  const { t } = useTranslation();

  return (
    <>
      <style>{keyframesStyle}</style>
      <Modal
        style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999 }}
        open={show}
        onClose={onClose}
      >
        <Fade in={show}>
          <div style={{ display: 'flex', width: getModalWidh(), alignItems: 'center', justifyContent: 'center' }}>
            <ModalContents style={{ width: '100%', padding: 15 }} onClose={onClose}>
              <>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    paddingTop: 5,
                  }}
                >
                  <img alt="" src={images.icon_check_circle} style={{ margin: '20px 0px' }} />
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontFamily: 'NSCJKrB',
                      color: 'black',
                      fontSize: 24,
                    }}
                  >
                    {t('choice_file_type')}
                  </div>
                  <VerticalSp sp={'1vw'} style={{ maxHeight: 40, minHeight: 24 }} />
                </div>
                <VerticalSp sp={'3vw'} style={{ maxHeight: 54, minHeight: 24 }} />
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 20 }}>
                  <ModalNorBtn
                    paymethod={true}
                    onClick={() => {
                      onDownloadFileChoice('png');
                    }}
                    style={{ width: '27%', padding: '0px 5px' }}
                  >
                    {t('select_PNG')}
                  </ModalNorBtn>
                  <HorizontalSp sp={10} />

                  <ModalNorBtn
                    paymethod={true}
                    onClick={() => {
                      onDownloadFileChoice('jpg');
                    }}
                    style={{ width: '27%', padding: '0px 5px' }}
                  >
                    {t('select_jpg+psd')}
                  </ModalNorBtn>
                </div>
                <div class="portone-ui-container" data-portone-ui-type="paypal-rt"></div>
              </>
            </ModalContents>
          </div>
        </Fade>
      </Modal>
    </>
  );
};

export const ModalContents = ({ children, style, onClose }) => {
  return (
    <div style={{ backgroundColor: 'white', borderRadius: 5, position: 'relative', ...style }} id="receipt">
      <div>{children}</div>
      <div onClick={onClose} style={{ position: 'absolute', top: 20, right: 20, cursor: 'pointer' }}>
        <img alt="" src={images.icon_close} />
      </div>
    </div>
  );
};

export const ChooseAfterCouponModal = ({ show, onClose, onSelFst, onSelSnd }) => {
  const { t } = useTranslation();
  return (
    <>
      <MediaQuery min={800}>
        <Modal style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999 }} open={show}>
          <Fade in={show}>
            <ModalContents style={{ width: getModalWidh() }} onClose={onClose}>
              <>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    paddingTop: 5,
                  }}
                >
                  <img alt="" src={images.icon_check_circle} style={{ margin: '20px 0px' }} />
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontFamily: 'NSCJKrB',
                      color: 'black',
                      fontSize: 24,
                    }}
                  >
                    {t('credit_coupon_complete')}
                  </div>
                  <VerticalSp sp={'1vw'} style={{ maxHeight: 40, minHeight: 24 }} />
                  <div style={{ fontFamily: 'NSCJKrR', color: 'black', fontSize: 15 }}>
                    <strong> {t('credit_coupon_complete2')}</strong>
                  </div>
                </div>
                <VerticalSp sp={'3vw'} style={{ maxHeight: 54, minHeight: 24 }} />
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 20 }}>
                  <ModalNorBtn paymethod={true} onClick={onClose} style={{ width: '27%', padding: '0px 5px' }}>
                    {t('cancel')}
                  </ModalNorBtn>
                  <HorizontalSp sp={10} />

                  <ModalNorBtn paymethod={true} onClick={onSelSnd} style={{ width: '27%', padding: '0px 5px' }}>
                    {t('confirm')}
                  </ModalNorBtn>
                </div>
                <div class="portone-ui-container" data-portone-ui-type="paypal-rt"></div>
              </>
            </ModalContents>
          </Fade>
        </Modal>
      </MediaQuery>
      <MediaQuery max={799}>
        <Modal style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999 }} open={show}>
          <Fade in={show}>
            <ModalContents style={{ width: getModalWidh() }} onClose={onClose}>
              <>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    paddingTop: 5,
                  }}
                >
                  <img alt="" src={images.icon_check_circle} style={{ margin: '20px 0px' }} />
                  <div style={{ fontFamily: 'NSCJKrB', color: 'black', fontSize: 16 }}>
                    {t('credit_coupon_complete')}
                  </div>
                  <VerticalSp sp={'1vw'} style={{ maxHeight: 54, minHeight: 24 }} />
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      fontFamily: 'NSCJKrR',
                      color: 'black',
                      fontSize: 13,
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <strong> {t('credit_coupon_complete2')}</strong>
                  </div>
                </div>
                <VerticalSp sp={'3vw'} style={{ maxHeight: 54, minHeight: 24 }} />
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 20 }}>
                  <ModalNorBtn paymethod={true} onClick={onClose} style={{ width: '27%', padding: '0px 5px' }}>
                    {t('cancel')}
                  </ModalNorBtn>
                  <HorizontalSp sp={10} />
                  <ModalNorBtn paymethod={true} onClick={onSelSnd} style={{ width: '27%', padding: '0px 5px' }}>
                    {t('confirm')}
                  </ModalNorBtn>
                </div>
              </>
            </ModalContents>
          </Fade>
        </Modal>
      </MediaQuery>
    </>
  );
};

export const SampleImageModal = ({ show, onClose, onSelectSampleImage, onUploadThumbClick, onStopSampleMode }) => {
  const generateFileList = (start, end, ext) => {
    return Array.from({ length: end - start + 1 }, (_, i) => `${start + i}.${ext}`);
  };

  const sampleArr = generateFileList(1, 66, 'jpg');

  const lang = getCurrentLang();

  const title = getStringByLang('샘플 이미지 선택', 'Select Sample Image', 'サンプル画像を選択');
  const subtitle = getStringByLang(
    '원하는 샘플 이미지를 선택하여 클릭해주세요.',
    'Please select a sample image and click it.',
    '希望のサンプル画像を選択してクリックしてください。',
  );
  const subtitle2 = getStringByLang(
    '생성될 이미지는 샘플 이미지를 바탕으로 만들어집니다.',
    'The generated image will be based on the sample image.',
    '生成される画像はサンプル画像を基に作成されます。',
  );
  const selectedImage = getStringByLang('파일 직접 선택', 'Select File Directly', 'ファイルを直接選択');

  const fileSelect = () => {
    onClose();
    onStopSampleMode();
    onUploadThumbClick();
  };
  const getWidth = () => {
    const width = window.innerWidth;
    let result;
    if (width > 1424) {
      result = '60%';
    } else if (width > 1224) {
      result = '65%';
    } else if (width > 1024) {
      result = '70%';
    } else {
      result = '90%';
    }

    return result;
  };

  return (
    <>
      <Modal
        style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999 }}
        open={show}
        onClose={onClose}
      >
        <Fade in={show}>
          <ModalContents style={{ width: getWidth() }} onClose={onClose}>
            <>
              <InView>
                <div
                  style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}
                >
                  <h1 style={{ marginBottom: 4 }}>{title}</h1>
                  <p style={{ margin: 0 }}>{subtitle}</p>
                  <p style={{ margin: 0 }}>{subtitle2}</p>
                  <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%', marginRight: 30 }}>
                    <Button
                      onClick={fileSelect}
                      style={{ display: 'flex', alignItems: 'center', padding: 3, marginTop: isMobile ? 0 : -30 }} // marginTop을 -5로 설정하여 위로 올립니다.
                    >
                      <img alt="" src={images.icon_plus} />
                      <div style={{ fontFamily: 'NSCJKrR', fontSize: 16, color: 'black', marginLeft: 10 }}>
                        {selectedImage}
                      </div>
                    </Button>
                  </div>

                  <div
                    style={{
                      display: 'grid',
                      width: '98%',
                      maxHeight: '70vh',
                      margin: '10px 15px 20px 20px',
                      gridTemplateColumns: `repeat(${isMobile ? 3 : 6}, 1fr)`,
                      overflowX: 'hidden', // 가로 스크롤 활성화
                      overflowY: 'scroll', // 세로 스크롤 비활성화
                    }}
                  >
                    {sampleArr.map((image, index) => (
                      <Ratio
                        key={index}
                        ratio={1}
                        onClick={() => onSelectSampleImage(image)}
                        style={{
                          width: '',
                          backgroundImage: `url(${process.env.REACT_APP_S3_BUCKET_DOMAIN}/tdb/storage/uploads/sample/${image})`,
                          backgroundSize: 'cover',
                          backgroundPosition: 'center',
                          backgroundRepeat: 'no-repeat',
                          transition: 'transform 0.3s, box-shadow 0.3s',
                          cursor: 'pointer',
                          position: 'relative',
                          margin: '3px',
                          zIndex: 1,
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = 'scale(1.2) translate(-5px, -5px)'; // 위쪽과 왼쪽으로 확대
                          e.currentTarget.style.border = '2px solid #fe8b07';
                          e.currentTarget.style.zIndex = 10;
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = 'scale(1) translate(0, 0)';
                          e.currentTarget.style.border = 'none';
                          e.currentTarget.style.zIndex = 1;
                        }}
                      ></Ratio>
                    ))}
                  </div>
                </div>
              </InView>
            </>
          </ModalContents>
        </Fade>
      </Modal>
    </>
  );
};
